import { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'
import { parseISO } from 'date-fns'
import format from 'date-fns/format'
import Link from 'next/link'
import { transactionProxy } from '../../../../../shared/proxies/transactionProxy'
import DetailLabel from '../../../../../shared/components/ui/forms/DetailLabel'
import { usdFormatter } from '../../../../../shared/utils/formattingUtils'
import PlainDetailLabel from '../../../../../shared/components/ui/forms/PlainDetailLabel'
import { PRETTY_TRANSACTION_TYPE, TransactionType } from '../../../../../shared/types/GlobalTranactionTypeEnum'
import { buildAppTransactionIdPrintPath } from '../../../../../pages/app/transactions/[id]/print'
import { executeResendEmailForTransaction } from '../../../../../shared/apiUtils/executeSendReceipt'
import PrimaryIconButton from '../../../../../shared/components/ui/buttons/PrimaryIconButton'
import PaperPlaneIcon from '../../../../../shared/components/ui/icons/PaperPlaneIcon'
import PrinterIcon from '../../../../../shared/components/ui/icons/PrinterIcon'

const formattedDate = (dateString: string): string => {
  const parsedDate = parseISO(dateString)
  return format(parsedDate, 'MMMM d, y')
}

export function PaymentDetailsTab (): ReactElement {
  const { transaction } = useSnapshot(transactionProxy)

  const amountCents = transaction?.amountCents ? usdFormatter.format(transaction.amountCents) : null

  return (
    <div>
      <div className="flex flex-row">
        <DetailLabel additionalOuterClasses="w-1/3" label="Invoice" value={transaction?.ppSslTransactionType ? PRETTY_TRANSACTION_TYPE[transaction.ppSslTransactionType] : 'Unspecified'} />
        <DetailLabel additionalOuterClasses="w-1/3" label="Original Amount" value={transaction?.ppSslTransactionType === TransactionType.Return ? `( ${amountCents} )` : amountCents} />
        <DetailLabel
          additionalOuterClasses="w-1/3" label="Refunded"
          value={transaction?.remainingAmountCents ? usdFormatter.format(transaction.amountCents - transaction.remainingAmountCents) : null}
        />
      </div>

      <div className="mt-6 flex flex-row">
        <DetailLabel additionalOuterClasses="w-1/3" label="Start Date" value={transaction?.transactedAt ? formattedDate(transaction?.transactedAt) : 'Unspecified'} />
        <DetailLabel additionalOuterClasses="w-1/3" label="Invoice" value={transaction?.invoiceNumber} />
        <DetailLabel additionalOuterClasses="w-1/3" label="Payment Method" value={transaction?.cardName} />
      </div>

      <div className=" mt-6 mb-4 pb-12 flex flex-row">
        <PlainDetailLabel label="Notes" value={transaction?.notes} />
      </div>

      <div className="flex flex-row">
        <PrimaryIconButton
          icon={<PaperPlaneIcon />}
          text="Resend Receipt"
          clickFunction={executeResendEmailForTransaction}
        />
        <Link className="ml-4" href={buildAppTransactionIdPrintPath(transaction?.id as string)} target="_blank">
          <PrimaryIconButton
            icon={<PrinterIcon />}
            text="Print Receipt"
            clickFunction={() => {
              return null
            }}
          />
        </Link>
      </div>

    </div>
  )
}
